import { useQuery } from '@tanstack/react-query'

import { getOrganizationMe } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchOrganizationMe = () => {
  const { axiosInstance } = useAxios()

  const { data, isError, isLoading, refetch, isFetched } = useQuery({
    queryFn: () => getOrganizationMe(axiosInstance),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_ORGANIZATION_ME],
  })

  return { data, isError, isLoading, refetch, isFetched }
}
